import React, { Component } from 'react';
import Slider from 'react-slick';
import SectionTitleOne from '../SectionTitleOne';

const videos = [
    'm_BporWs90w',
    'kSReZYMSaaE',
    'Px3vpBJ_3UY',
    'XLZzHOZdIPA',
];

const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    arrows: false,
    responsive: [
        {
            breakpoint: 9999,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
    ],
};

class VideoEmbed extends Component {
    constructor(props) {
        super(props);
        this.state = { active: false, thumb: `https://img.youtube.com/vi/${props.id}/maxresdefault.jpg` };
    }

    handleThumbError() {
        this.setState({ thumb: `https://img.youtube.com/vi/${this.props.id}/hqdefault.jpg` });
    }

    render() {
        const { id } = this.props;
        const { active, thumb } = this.state;

        return (
            <div
                style={{ position: 'relative', paddingBottom: '177.77%', height: 0, overflow: 'hidden', borderRadius: '8px', background: '#000', cursor: active ? 'default' : 'pointer' }}
                onClick={() => !active && this.setState({ active: true })}
            >
                {active ? (
                    <iframe
                        src={`https://www.youtube.com/embed/${id}?autoplay=1`}
                        title={`Testimonial ${id}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    />
                ) : (
                    <>
                        <img
                            src={thumb}
                            alt="Watch testimonial"
                            onError={() => this.handleThumbError()}
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                        {/* YouTube official play button shape */}
                        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', pointerEvents: 'none' }}>
                            <svg height="46" width="68" viewBox="0 0 68 46" xmlns="http://www.w3.org/2000/svg">
                                <path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 23 0 23s.06 9.95 1.48 15.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 45.87 34 46 34 46s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 32.95 68 23 68 23s-.06-9.95-1.48-15.26z" fill="#f00"/>
                                <path d="M45 23 27 14v18z" fill="#fff"/>
                            </svg>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

class TestimonailOne extends Component {
    render() {
        return (
            <section className="testimonial-one-wrapper section-padding">
                <div className="container">
                    <SectionTitleOne BigTitle="Testimonials" />

                    {/* Desktop: all 4 in one row */}
                    <div className="d-none d-lg-flex row">
                        {videos.map((id) => (
                            <div key={id} className="col-3">
                                <VideoEmbed id={id} />
                            </div>
                        ))}
                    </div>

                    {/* Tablet + Mobile: slider */}
                    <div className="d-lg-none">
                        <Slider {...sliderSettings}>
                            {videos.map((id) => (
                                <div key={id} className="px-2">
                                    <VideoEmbed id={id} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        );
    }
}

export default TestimonailOne;
